import { Link, NavLink, Outlet } from "react-router-dom";
import { Images, Inbox, LogOut, ExternalLink, Star, HelpCircle, Megaphone, Settings2, ShoppingBag } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { LOGO } from "../../lib/content";

const tab = ({ isActive }) => `flex shrink-0 items-center gap-1 rounded-full px-2.5 py-2 text-[13px] font-semibold transition-colors sm:gap-2 sm:px-4 sm:text-sm ${isActive ? "bg-[#FF1F8E] text-white" : "text-white/75 hover:text-white"}`;

export default function AdminLayout() {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen overflow-x-hidden bg-[#FFF4F8]">
      <header className="bg-[#0E0B0D]">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-3 px-4 py-3 sm:px-6 lg:flex-nowrap">
          <Link to="/" className="rounded-xl bg-white px-2 py-1"><img src={LOGO} alt="KMK" className="h-9" /></Link>
          <nav className="order-last flex w-full flex-wrap gap-1 md:order-none md:w-auto" data-testid="admin-nav">
            <NavLink to="/admin" end className={tab} data-testid="admin-tab-requests"><Inbox className="h-4 w-4" />Requests</NavLink>
            <NavLink to="/admin/gallery" className={tab} data-testid="admin-tab-gallery"><Images className="h-4 w-4" />Gallery</NavLink>
            <NavLink to="/admin/reviews" className={tab} data-testid="admin-tab-reviews"><Star className="h-4 w-4" />Reviews</NavLink>
            <NavLink to="/admin/shop" className={tab} data-testid="admin-tab-shop"><ShoppingBag className="h-4 w-4" />Shop</NavLink>
            <NavLink to="/admin/promotions" className={tab} data-testid="admin-tab-promotions"><Megaphone className="h-4 w-4" />Promos</NavLink>
            <NavLink to="/admin/site" className={tab} data-testid="admin-tab-site"><Settings2 className="h-4 w-4" />Site Info</NavLink>
            <NavLink to="/admin/help" className={tab} data-testid="admin-tab-help"><HelpCircle className="h-4 w-4" />Help</NavLink>
          </nav>
          <div className="flex items-center gap-2">
            <Link to="/" className="rounded-full p-2 text-white/70 hover:text-white" title="View site" data-testid="admin-view-site"><ExternalLink className="h-4 w-4" /></Link>
            <button onClick={logout} className="flex items-center gap-1.5 rounded-full border border-[#D4A537] px-4 py-2 text-sm text-[#EBD08A] hover:bg-[#D4A537] hover:text-black" data-testid="admin-logout-btn"><LogOut className="h-4 w-4" />Log out</button>
          </div>
        </div>
        <div className="stitch-line" />
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6"><Outlet /></main>
    </div>
  );
}
